<template>
	<div>
		<el-row>
			<el-col :span="16" class="left-breadcrumb">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item>缺陷筛查</el-breadcrumb-item>
					<el-breadcrumb-item>批次列表</el-breadcrumb-item>
					<el-breadcrumb-item>缺陷报表</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
			<el-col :span="8" class="right-actions">
				<el-tooltip class="item" effect="dark" content="返回" placement="left">
					<el-button icon="el-icon-arrow-left" circle></el-button>
				</el-tooltip>
			</el-col>
		</el-row>

		<div style="margin-top:30px">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="" name="first">
					<div>
						<table class="table">
							<tbody>
								<tr>
									<th style="width:120px">产品名称：</th>
									<td colspan="3">1111</td>
								</tr>
								<tr>
									<th>检测批次：</th>
									<td>111</td>
									<th style="width:120px">检测时间</th>
									<td>2020-05-01</td>
								</tr>
							</tbody>
						</table>
					</div>
				</el-tab-pane>
				<el-tab-pane label="缺陷分布统计图" name="second">
					<ve-pie :data="chartData"></ve-pie>
				</el-tab-pane>
				<el-tab-pane label="产品图像" name="third">产品图像</el-tab-pane>
				<el-tab-pane label="缺陷样本" name="fourth">缺陷样本</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import VePie from 'v-charts/lib/pie.common'
	export default {
		components: {
			VePie,
		},
		data() {
			return {
				activeName: 'second',
				chartData: {
					columns: ['良率', '速度', '张力'],
					rows: [
						{米数: '0米', 良率: 89, 速度: 87, 张力: 32},
						{米数: '100米', 良率: 89, 速度: 88, 张力: 26},
						{米数: '200米', 良率: 99, 速度: 98, 张力: 76},
						{米数: '300米', 良率: 79, 速度: 80, 张力: 49},
						{米数: '400米', 良率: 91, 速度: 100, 张力: 323},
						{米数: '500米', 良率: 82, 速度: 77, 张力: 78},
						{米数: '600米', 良率: 80, 速度: 87, 张力: 88},
					],
				},
			}
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event)
			},
		},
	}
</script>

<style lang="less" scoped>
	.table {
		width: 100%;
		border-collapse: collapse;
		td,
		th {
			border-bottom: 1px #ddd solid;
			padding: 15px 5px;
			font-size: 14px;
		}
	}
</style>
